import { render, staticRenderFns } from "./trustpilot-reviews.vue?vue&type=template&id=ce10f53c&"
import script from "./trustpilot-reviews.vue?vue&type=script&lang=js&"
export * from "./trustpilot-reviews.vue?vue&type=script&lang=js&"
import style0 from "./trustpilot-reviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TrustpilotWidget: require('/usr/src/app/components/common-sections/trustpilot-widget.vue').default})
